import { render } from "./CustomerBoard.vue?vue&type=template&id=dfee424a"
import script from "./CustomerBoard.vue?vue&type=script&lang=js"
export * from "./CustomerBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__